import { Dashboard } from '@mui/icons-material'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import React from 'react'
import RunningJourneyBtn from './component/RunningJourneyBtn'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
function RunningJourney() {
  return (
   <DashboardLayout>
    <DashboardNavbar />
     <RunningJourneyBtn />
   </DashboardLayout>
  )
}

export default RunningJourney
